import React from 'react';

/**
 * This is the commit message of the last commit before building or running this project
 * @see ./package.json git-info for how to generate this commit
 */
import GitCommit from '../_git_commit';

const VersionComponent = () => (
  <div className='text-muted text-sm'>{GitCommit.sha} - {GitCommit.time}</div>
);

export default VersionComponent;



// WEBPACK FOOTER //
// ./src/components/VersionComponent.js